import { baseClasses } from '@weatherbug/common';
import { FeaturedCategoryWeatherCamProvider } from '../providers/featuredCategoriesWeatherCamProvider';

const { AsyncAction } = baseClasses;

export const GET_FEATURED_WEATHER_CAMS = new AsyncAction('GET_FEATURED_WEATHER_CAMS');
export const GET_CATEGORIES_WEATHER_CAMS = new AsyncAction('GET_CATEGORIES_WEATHER_CAMS');

export function getFeaturedWeatherCams(category, numberOfFeaturedCams, verbose, stdParams, refresh) {
    return {
        type: GET_FEATURED_WEATHER_CAMS.base,
        payload: getFeaturedWeatherCamsAction(category, numberOfFeaturedCams, verbose, stdParams, refresh)
    };
}

async function getFeaturedWeatherCamsAction(category, numberOfFeaturedCams, verbose, stdParams, refresh) {
    const op = new FeaturedCategoryWeatherCamProvider();
    return await op.getFeaturedWeatherCams(category, numberOfFeaturedCams, verbose, stdParams, refresh);
}

export function getCategoriesWeatherCams(category, numberOfCategoriesCams, verbose, stdParams, refresh) {
    return {
        type: GET_CATEGORIES_WEATHER_CAMS.base,
        payload: getCategoriesWeatherCamsAction(category, numberOfCategoriesCams, verbose, stdParams, refresh)
    };
}

async function getCategoriesWeatherCamsAction(category, numberOfCategoriesCams, verbose, stdParams, refresh) {
    const op = new FeaturedCategoryWeatherCamProvider();
    return await op.getCategoriesWeatherCams(category, numberOfCategoriesCams, verbose, stdParams, refresh);
}
